<div class="notes">
  @if (discussionViewModels.length > 0) {
    <ul class="note-list">
      @for (d of discussionViewModels; track d) {
        <li class="note">
          <div class="note-head">
            <span class="note-author">{{d.userName}}</span>
            @if (d.timestamp != null) {
              <span class="note-time" [matTooltip]="d.formattedDate">{{d.timestamp?.seconds * 1000 | timeAgo}}</span>
            }
            @if (d.currentUser) {
              <button class="note-delete" type="button" [disabled]="disabled" (click)="deleteMessage.emit(d)"
                matTooltip="Delete note" aria-label="Delete note">
                <mat-icon>delete_outline</mat-icon>
              </button>
            }
          </div>
          <div class="note-body" [innerHtml]="d.description | safeHtml"></div>
        </li>
      }
    </ul>
  } @else {
    <p class="note-empty">No notes yet.</p>
  }

  @if (!disabled) {
    <form class="note-composer" (ngSubmit)="submit()">
      <app-mention-textbox [(content)]="newMessage" [placeholder]="'Leave a note...'">
        <button class="note-send" [disabled]="sending" (click)="send()" matTooltip="Post note" aria-label="Post note">
          @if (sending) {
            <mat-spinner diameter="18" strokeWidth="2"></mat-spinner>
          } @else {
            <mat-icon>send</mat-icon>
          }
        </button>
      </app-mention-textbox>
    </form>
  }
</div>
